import { RouteConfig } from 'vue-router';
import { requireProvider } from '@/router/guards/authGuards';
import { checkSitterOnboarding } from '@/router/guards/completionGuards';
import combineGuards from '@/router/guards/helpers';

const bookingsRoutes: RouteConfig[] = [
  {
    path: '/provider/bookings',
    name: 'provider-bookings',
    component: () => import('@/apps/provider/bookings/ProviderBookings.vue'),
    beforeEnter: combineGuards([requireProvider, checkSitterOnboarding]),
  },
];

export default bookingsRoutes;
